/* eslint-disable camelcase */
import request from '@shared/h5/utils/request-new';
import conf from '@/conf';

const isProd = process.env.NODE_ENV === 'production';

export function getArticleDetail(fid: string, efid: string, u?: number, token?: string) {
  return request
    .get('/sdk/content/article/detail', {
      baseURL: conf.node_url,
      params: {
        fid,
        efid,
        u,
        access_token: token,
      },
    })
    .then((res) => res.data);
}

export function getRelatedArticle(fid: string, efid: string) {
  return request
    .get('/sdk/seo/related/articles', {
      baseURL: conf.node_url,
      params: {
        fid,
        efid,
        count: 5,
      },
    })
    .then((res) => res.data);
}

export function getArticleComment(fid, page, count = 10) {
  return request
    .get('/sdk/article/get_comments', {
      baseURL: isProd ? conf.node_url : null,
      params: {
        fid,
        page,
        count,
      },
    })
    .then((res) => res.data);
}

export function fetchCommentLike(cid: number, like: number) {
  return request
    .get('/sdk/web/content/fetch_cmt_like', {
      baseURL: isProd ? conf.node_url : null,
      params: {
        cid,
        like,
      },
    })
    .then((res) => res?.data);
}

export function getWxConfig() {
  return request
    .get('/sdk/activity/wechat/config', {
      baseURL: isProd ? conf.node_url : null,
    })
    .then((res) => res?.data);
}

export interface HotCompanyResponse {
  data: HotCompanyDatum[];
  result: string;
}

export interface HotCompanyDatum {
  webcid: string;
  job_cnt: number;
  name: string;
  cid: number;
  user_cnt: number;
  clogo: string;
}
// export function fetchHotCompany(fid: string, count = 5) {
//   return request
//     .get<HotCompanyResponse>('/search/seo/article_hot_company', {
//       baseURL: conf.inner_online_url,
//       params: {
//         fid,
//         count,
//       },
//     })
//     .then((res) => res?.data?.data || []);
// }
